import makeObservable from '../utils/makeObservable';

export const CONTEXT_MENU_STORE = makeObservable(null);